import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { bannerComics } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % bannerComics.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + bannerComics.length) % bannerComics.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const banner = bannerComics[current];

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${banner.cover})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-4">
          {banner.tag}
        </span>
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">
          {banner.title}
        </h1>
        <p className="text-sm md:text-base text-background-200/90 max-w-lg mb-6">
          {banner.description}
        </p>
        <Link
          to={`/article/${banner.id}`}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          <span>立即阅读</span>
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 transition-all cursor-pointer"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 transition-all cursor-pointer"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {bannerComics.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current ? 'bg-background-50 w-6' : 'bg-background-50/50'
            }`}
            aria-label={`切换到第 ${i + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}